module.exports = __webpack_public_path__ + "static/img/LICMcargoLogo.4a8dca1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/LICMcargoLogo.jpg
// module id = 0ZEj
// module chunks = 1